import request from '@/request/request'

/**
 * // 获取用户信息
 * @param {} parameter 
 * @returns 
 */
export function personalInfo () {
  return request({
    url: '/e-find-user/testPersonalCenter/personalInfo',
    method: 'get',
  })
}

/**
 * 同步联交所自然人、企业及证照基础信息
 */
export function syncMainPlatformUserInfo () {
  return request({
    url: '/e-find-user/testPersonalCenter/syncMainPlatformUserInfo',
    method: 'post'
  })
}

/**
 * // 创建人脸核身(腾讯云)
 * @param {} parameter 
 * @returns 
 */
export function creatTencentFaceId (parameter) {
  return request({
    url: '/e-find-user/testPersonalCenter/creatTencentFaceId',
    method: 'post',
    data: parameter
  })
}

/**
 * // 更新密码
 * @param {} parameter 
 * @returns 
 */
export function updatePassword (parameter) {
  return request({
    url: '/e-find-user/testPersonalCenter/updatePassword',
    method: 'post',
    data: parameter
  })
}

/**
 * // 获取申请用户信息
 * @param {} parameter 
 * @returns 
 */
export function applyPersonalInfo () {
  return request({
    url: '/e-find-user/testPersonalCenter/applyPersonalInfo',
    method: 'get',
  })
}

